import { render, staticRenderFns } from "./QuestionTypeSelectOptions.vue?vue&type=template&id=96541b00&scoped=true"
import script from "./QuestionTypeSelectOptions.vue?vue&type=script&lang=js"
export * from "./QuestionTypeSelectOptions.vue?vue&type=script&lang=js"
import style0 from "./QuestionTypeSelectOptions.vue?vue&type=style&index=0&id=96541b00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96541b00",
  null
  
)

export default component.exports